import {AfterViewInit, Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormControl, Validators} from '@angular/forms';
import {positiveNumberValidator} from '../../validators/positiveNumber.validator';
import {intValidator} from '../../validators/int.validator';
import {Product} from '../../model/Entities/Product';
import {AvailabilityService} from '../../services/availability.service';
import {ProductTransferService} from '../../services/product-transfer.service';
import {ProductTransfer} from '../../model/Entities/ProductTransfer';

@Component({
    selector: 'product-transfer-dialog',
    templateUrl: './product-transfer.dialog.component.html',
    styleUrls: ['./product-transfer.dialog.component.scss']
})
export class ProductTransferDialogComponent implements AfterViewInit {

    public static DIRECTION_OUT = 'out';
    public static DIRECTION_IN = 'in';

    @ViewChild('countInput') countInput: ElementRef;

    public product: Product;
    public direction: any;
    public count = 0;
    public originalCount = 0;
    public remainingCountIsNotEnough = false;

    countFC = new FormControl('', [
        Validators.required,
        intValidator(),
        positiveNumberValidator()
    ]);

    constructor(public dialog: MatDialogRef<ProductTransferDialogComponent>,
                private productTransferService: ProductTransferService,
                private availabilityService: AvailabilityService,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.product = data.product;
        this.originalCount = this.product.count;
        this.direction = data.direction;
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.countInput.nativeElement.select();
            this.countInput.nativeElement.focus();
        }, 100);
    }

    checkValidity(): boolean {
        return (this.direction === ProductTransferDialogComponent.DIRECTION_IN
            || (this.direction === ProductTransferDialogComponent.DIRECTION_OUT && this.count <= this.product.count))
            && this.countFC.valid;
    }

    saveChanges(): void {

        const transfer: ProductTransfer = new ProductTransfer();
        transfer.productId = this.product.id;

        switch (this.direction) {
            case ProductTransferDialogComponent.DIRECTION_IN:
                transfer.count = +this.count;
                break;
            case ProductTransferDialogComponent.DIRECTION_OUT:
                transfer.count = -this.count;
                break;
        }
        this.productTransferService.save(transfer).subscribe((result: ProductTransfer) => {
            this.dialog.close(true);
        }, error => {
            if (error.status === 400) {
                this.remainingCountIsNotEnough = true;
            }
        });

    }
}



// WEBPACK FOOTER //
// /app/src/ProductsModule/ProductTransferDialogComponent/product-transfer.dialog.component.ts